import FreeWriteBuilderModalEnum from './FreeWriteBuilderModalConstants';

export const closeFreeWriteOnboardingModal = modal => (
  (dispatch) => {
    dispatch({
      type: FreeWriteBuilderModalEnum.FREEWRITE_MODAL_CLOSE,
      modalType: modal,
    });
  }
);

export const openFreeWriteOnboardingModal = modal => (
  (dispatch) => {
    dispatch({
      type: FreeWriteBuilderModalEnum.FREEWRITE_MODAL_OPEN,
      modalType: modal,
    });
  }
);



// WEBPACK FOOTER //
// ./src-react/FreeWriteBuilderModals/FreeWriteBuilderModalActions.jsx